<template>
  <section>
    <main
      class="main animated fadeIn faster"
      :class="{ 'expand-main': isMenuCollapse }"
    >
      <div class="contenedor py-0">
        <div class="row d-flex flex-row px-0 mx-0">
          <div class="col=12 w-100 mb-2" v-if="!loading">
            <div class="row  ml-3">
              <h2>Bookers Calls</h2>
            </div>
            <div
              class="container-fluid w-100 mb-3 p-3 border bg-white rounded stats-wrapper"
            >
              <div class="d-flex flex-wrap">
                <!-- FILA 1 -->

                <!-- DATE FROM -->
                <div class="w-50 input-group input-group-sm p-1">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-sm"
                      >From</span
                    >
                  </div>
                  <date-picker
                    id="startDatePicker"
                    class="form-control"
                    v-model="model.range.startDate"
                    :config="datePickerConfig"
                    placeholder="Start Date"
                  ></date-picker>

                  <!-- DATE TO -->
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-sm"
                      >to</span
                    >
                  </div>
                  <date-picker
                    id="endDatePicker"
                    class="form-control"
                    v-model="model.range.endDate"
                    :config="datePickerConfigEndDate"
                    placeholder="End Date"
                  ></date-picker>
                </div>
                <br />
                <!-- FILA 2 -->
                <!-- BDR -->
                <div
                  class="w-50 input-group input-group-sm p-1 treeselect-wrapper"
                  v-if="['1', '9'].includes(currentUser.role_id) || (currentUser.booker && currentUser.booker.status == 'Booker Manager')"
                >
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-sm"
                      >BDR</span
                    >
                  </div>
                  <treeselect
                    v-model="model.bdrUserFilter"
                    :options="bdrUserOptions"
                    :normalizer="normalizeOptions"
                    :multiple="true"
                    class="form-control inline-table"
                  >
                  </treeselect>
                </div>

                <!-- FILA 3 -->

                <!-- TASK TYPE -->
                <div
                  class="w-25 input-group input-group-sm p-1 treeselect-wrapper"
                >
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-sm"
                      >{{ $t("lang.label.results") }}</span
                    >
                  </div>
                  <treeselect
                    :disabled="currentUser.role_id != 1"
                    v-model="model.result"
                    :options="resultTypeOption"
                    :multiple="true"
                    class="form-control inline-table"
                  >
                  </treeselect>
                </div>
                <div
                  class="w-25 input-group input-group-sm p-1 treeselect-wrapper"
                >
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-sm"
                      >{{ $t("lang.label.filter-temperature_status") }}</span
                    >
                  </div>
                  <treeselect
                    v-model="model.temperatureStatusFilter"
                    :options="temperatureStatuseOptions"
                    :multiple="true"
                    class="form-control inline-table"
                  >
                  </treeselect>
                </div>
                <div
                  class="w-25 input-group input-group-sm p-1 treeselect-wrapper"
                >
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-sm"
                      >{{ $t("lang.label.phone") }}</span
                    >
                  </div>
                  <input type="text" class="form-control inline-table"
                    v-model="model.phoneFilter" placeholder="Phone number" />
                </div>
                <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-sm"
                      >Booker Type</span
                    >
                  </div>
                  <select class="form-control" v-model="model.booker_type">
                    <option value="all">All Types</option>
                    <option value="human">Human</option>
                    <option value="ai_agent">Agent AI</option>
                  </select>
                </div>
                <div class="w-25 p-1 ml-auto">
                  <div class="col-md-12 d-flex justify-content-end my-2">
                    <button
                      class="btn btn-success"
                      :disabled="loading"
                      @click="getCalls()"
                    >
                      <i class="icon-calendar-check-o mr-2"></i>
                      <small>
                        {{ $t("lang.label.letsgetstarted") }}
                      </small>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12 w-100 mb-3 card p-2">
              <div class="row">
                <div class="col-md-12">
                  <div class="bd-highlight">
                    {{ $t("lang.label.results") }}:
                    <small v-if="!total" class="ml-1 text-primary mr-4"
                      >{{ $t("lang.search.calculating") }}...</small
                    >
                    <strong v-else>{{ total }}</strong>
                    <button class="ml-2 btn btn-sm btn-primary" 
                      @click="getToDownload()"
                      :disabled="processingAllItems"
                      >
                      <span v-if="!processingAllItems">
                        Download csv
                      </span>
                      <span v-else>Processing...</span>
                    </button>
                  </div>
                  <div class="text-center mb-2">
                    <Pagination
                      v-if="!loading"
                      :total="total"
                      :totalpage="calls.length"
                      :model="model"
                      :limit="false"
                      :color="'primary'"
                      @changePage="getCalls"
                      key="paginationkey"
                    >
                    </Pagination>
                  </div>
                </div>
              </div>
              <div class="mx-0 px-0 table-responsive">
                <Table
                  v-if="!loading"
                  class="mx-2 w-100"
                  :headers="headers"
                  :cols="cols"
                  :checkbox="false"
                  :notselect="true"
                  :model="[]"
                  :data="calls"
                  :key="200"
                  @openOportunity="openOportunity"
                  @openClient="openClient"
                  @showTranscription="showTranscription"
                >
                </Table>
              </div>
            </div>
          </div>
        </div>
        <LoadingSpinner v-if="loading" />

        <!-- Tabla de datos -->
      </div>
    </main>
     <Modal :name="'transcription-modal'" :size="'60'" :max-width="'650'" :close="true">
      <div class="px-3">
        <h2>Transcription</h2>
       <div v-html="actualTranscription"></div>
       
      </div>
    </Modal>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { adminService, usersService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Treeselect from "@riophae/vue-treeselect";
import Pagination from "@/components/Common/Pagination.vue";
import moment from "moment";
import Modal from "@/components/Common/Modal.vue";
import { type } from "jquery";

export default {
  name: "BookersCalls",
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      filtersSystem: (state) => state.campaigns.filtersSystem,
    }),
    ordersPreparingAndNotVerified() {
      return this.ordersStatus.filter(
        (el) => el.target_status_id === "1" && el.target_validation === "0"
      );
    },
    ordersPreparingAndVerified() {
      return this.ordersStatus.filter(
        (el) =>
          el.target_status_id === "1" &&
          el.target_validation === "1" &&
          parseInt(el.prospectors_active) > 3
      );
    },
  },

  data() {
    return {
      calls: [],
      callsAllItems: [],
      bdrUserOptions: [],
      actualTranscription: '',
      loading: true,
      datePickerConfig: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        // minDate: moment().startOf("day")
        maxDate: moment().endOf("day"),
      },
      datePickerConfigEndDate: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        maxDate: moment().endOf("day"),
      },
      temperatureStatuseOptions: [
        {
          id: "1",
          label: "Urgent",
        },
        {
          id: "2",
          label: "Positive",
        },
        {
          id: "3",
          label: "Introduction",
        },
        {
          id: "4",
          label: "Wrong contact",
        },
        {
          id: "5",
          label: "Negative",
        },
        {
          id: "6",
          label: "Calendar inspection",
        },
        {
          id: "7",
          label: "Reschedule",
        },
        {
          id: "8",
          label: "Cold",
        },
        {
          id: "9",
          label: "Other Answer",
        },
      ],
      resultTypeOption: [
        {
          id: "wrongnumber",
          label: "Wrong Number",
        },
        {
          id: "nointeraction",
          label: "No Interaction",
        },
        {
          id: "conversation",
          label: "Conversation",
        },
      ],
      cols: [
        [
          {
            value: "created_at",
          },
        ],
        [
          {
            value: "from_name",
          },
        ],
        [
          {
            value: "to_name",
          },
        ],
        [
          {
            value: "to_number_call",
          },
        ],
        [
          {
            type: "emit",
            emit: "openOportunity",
            value_label: "opportunity_name",
            value_emit: "link_id",
            class: "text-primary",
          },
        ],
        [
          {
            type: "emit",
            emit: "openClient",
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
          },
        ],
        [
          {
            value_label: "call_state",
            class: "text-primary",
            textShort: 40,
            badges: [
              {
                badge_if: "call_state",
                badge_value: "FAILED",
                badge_class: "badge badge-danger text-white",
                badge_label: "FAILED",
              },
              {
                badge_if: "call_state",
                badge_value: "CALL_ID_FAILED",
                badge_class: "badge badge-danger text-white",
                badge_label: "FAILED",
              },
              {
                badge_if: "call_state",
                badge_value: "ANSWERED",
                badge_class: "badge badge-success text-white",
                badge_label: "ANSWERED",
              },
              {
                badge_if: "call_state",
                badge_value: "CANCELLED",
                badge_class: "badge badge-warning text-white",
                badge_label: "CANCELLED",
              },
            ],
          },
        ],
        [
          {
            value_label: "Result",
            class: "text-primary",
            textShort: 40,
            badges: [
              {
                badge_if: "result",
                badge_value: "wrongnumber",
                badge_class: "badge badge-danger text-white",
                badge_label: "Wrong number",
              },
              {
                badge_if: "result",
                badge_value: "Conversation",
                badge_class: "badge badge-success text-white",
                badge_label: "Conversation",
              },
              {
                badge_if: "result",
                badge_value: "nointeraction",
                badge_class: "badge badge-secondary text-white",
                badge_label: "No interaction",
              },
            ],
          },
        ],
        [
          {
            value: "link_status_temperature_id",
            type: "itemBadge",
            class: "badge badge-primary",
            colors: [
              {
                id: 1,
                label: "Urgent",
                bgColor: "#008000",
                textColor: "#FFFFFF",
              },
              {
                id: 2,
                label: "Positive",
                bgColor: "#008000",
                textColor: "#FFFFFF",
              },
              {
                id: 3,
                label: "Introduction",
                bgColor: "#0000FF",
                textColor: "#FFFFFF",
              },
              {
                id: 4,
                label: "Wrong Contact",
                bgColor: "#0000FF",
                textColor: "#FFFFFF",
              },
              {
                id: 5,
                label: "Negative",
                bgColor: "#0000FF",
                textColor: "#FFFFFF",
              },
              {
                id: 6,
                label: "Calendar Inspection",
                bgColor: "#00FFFF",
                textColor: "#000000",
              },
              {
                id: 7,
                label: "Reschedule",
                bgColor: "#FFFF00",
                textColor: "#000000",
              },
              {
                id: 8,
                label: "Cold",
                bgColor: "#000000",
                textColor: "#FFFFFF",
              },
              {
                id: 9,
                label: "Other Answer",
                bgColor: "#FF9966",
                textColor: "#000000",
              },
            ],
          },
        ],
        [        
            {
              value: "qualification",
              type: "itemBadge",
              class: "badge",
              colors: [
                {
                  id: "MEETING_BOOKED",
                  label: "MEETING BOOKED",
                  bgColor: "#28a745",
                  textColor: "#FFFFFF",
                  tooltipRowField: "qualification_response",
                },
                {
                  id: "MEETING_RESCHEDULED",
                  label: "MEETING RESCHEDULED",
                  bgColor: "#fd7e14",
                  textColor: "#FFFFFF",
                  tooltipRowField: "qualification_response",
                },
                {
                  id: "MEETING_REFUSED_SEND_EMAIL",
                  label: "MEETING REFUSED SEND EMAIL",
                  bgColor: "#6c757d",
                  textColor: "#FFFFFF",
                  tooltipRowField: "qualification_response",
                },
                {
                  id: "CALLBACK_REQUESTED",
                  label: "CALLBACK REQUESTED",
                  bgColor: "#6c757d",
                  textColor: "#FFFFFF",
                  tooltipRowField: "qualification_response",
                },
                {
                  id: "SOFT_REFUSAL",
                  label: "SOFT REFUSAL",
                  bgColor: "#6c757d",
                  textColor: "#FFFFFF",
                  tooltipRowField: "qualification_response",
                },
                {
                  id: "HARD_REFUSAL",
                  label: "HARD REFUSAL",
                  bgColor: "#6c757d",
                  textColor: "#FFFFFF",
                  tooltipRowField: "qualification_response",
                },
                {
                  id: "OPT_OUT_REQUEST",
                  label: "OPT OUT REQUEST",
                  bgColor: "#6c757d",
                  textColor: "#FFFFFF",
                  tooltipRowField: "qualification_response",
                },
                {
                  id: "WRONG_PERSON",
                  label: "WRONG PERSON",
                  bgColor: "#6c757d",
                  textColor: "#FFFFFF",
                  tooltipRowField: "qualification_response",
                },
                {
                  id: "NOT_DECISION_MAKER",
                  label: "NOT DECISION MAKER",
                  bgColor: "#6c757d",
                  textColor: "#FFFFFF",
                  tooltipRowField: "qualification_response",
                },
                {
                  id: "OUT_OF_SCOPE",
                  label: "OUT OF SCOPE",
                  bgColor: "#6c757d",
                  textColor: "#FFFFFF",
                  tooltipRowField: "qualification_response",
                },
                {
                  id: "CALL_INTERRUPTED",
                  label: "CALL INTERRUPTED",
                  bgColor: "#6c757d",
                  textColor: "#FFFFFF",
                  tooltipRowField: "qualification_response",
                },
                {
                  id: "VOICEMAIL_PITCH_LEFT",
                  label: "VOICEMAIL PITCH LEFT",
                  bgColor: "#6c757d",
                  textColor: "#FFFFFF",
                  tooltipRowField: "qualification_response",
                },
                {
                  id: "VOICEMAIL_NO_PITCH",
                  label: "VOICEMAIL NO PITCH",
                  bgColor: "#6c757d",
                  textColor: "#FFFFFF",
                  tooltipRowField: "qualification_response",
                },
                {
                  id: "NO_ANSWER",
                  label: "NO ANSWER",
                  bgColor: "#6c757d",
                  textColor: "#FFFFFF",
                  tooltipRowField: "qualification_response",
                },
              ],
            },
          ],
        [
            {
              value: "calification",
              type: "itemBadge",
              class: "badge",
              colors: [
                {
                  id: "new_meeting",
                  label: "New meeting",
                  bgColor: "#28a745",
                  textColor: "#FFFFFF",
                  tooltipRowField: "calification_response",
                },
                {
                  id: "rescheduled_meeting",
                  label: "Rescheduled meeting",
                  bgColor: "#fd7e14",
                  textColor: "#FFFFFF",
                  tooltipRowField: "calification_response",
                },
                {
                  id: "no_meeting",
                  label: "No meeting",
                  bgColor: "#6c757d",
                  textColor: "#FFFFFF",
                  tooltipRowField: "calification_response",
                },
              ],
            },
          ],

        [
              
          {
            type: "multiple",
            conditions: [
                {
                value_if: "has_transcription",
                value: "1",
                class: "icon-bars text-primary mr-2",
                type: "icon",
                type2: "emit",
                emit: "showTranscription",
              },
              {
                value_if: "record",
                value_audio: "record",
                type: "audio",
                value_source_type: "source_type", 
                value_conversation_id: "call_id",
              },
            
            ]
          }
        ],
      ],
      headers: [
        {
          label: "date call",
          percentage: "10.5%",
          class: "overflowhide",
          id: 1,
        },
        {
          label: "Call From",
          percentage: "10.5%",
          class: "overflowhide",
          id: 2,
        },
        {
          label: "Call To",
          percentage: "10.5%",
          class: "overflowhide",
          id: 3,
        },
        {
          label: "Call number",
          percentage: "12.5%",
          class: "overflowhide",
          id: 4,
        },
        {
          label: "Oportunity",
          percentage: "10.5%",
          class: "overflowhide",
          id: 5,
        },
        {
          label: "Client",
          percentage: "12.5%",
          class: "overflowhide",
          id: 6,          
        },
        {
          label: "Call Status",
          percentage: "12.5%",
          class: "overflowhide",
          id: 7,          
        },
        {
          label: "Result",
          percentage: "12.5%",
          class: "overflowhide",
          id: 8,          
        },
        {
          label: "Opportunity Temperature",
          percentage: "12.5%",
          class: "overflowhide",
          id: 9,          
        },
        {
          label: "Qualification",
          class: "overflowhide",
          id: 10,
        }, 
        {
          label: "Clasification",
          class: "overflowhide",
          id: 11,
        }, 
        {
          label: "Archive",
          percentage: "12.5%",
          class: "overflowhide",
          id: 12,
        },
      ],
      getOrderNumber: 0,
      responseOrderNumber: 0,
      total: 0,
      processingAllItems:false,
      model: {
        temperatureStatusFilter: [],
        bdrUserFilter: [],
        booker_type: "all",
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
        result: [],
        range: {
          startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
        },
      },
    };
  },
  components: {
    Table,
    LoadingSpinner,
    Pagination,
    Treeselect,
    Modal
  },
  mounted() {
    if (this.currentUser.role_id != 1 && this.currentUser.role_id != 9) {
      this.model.bdrUserFilter.push(this.currentUser.id);
      this.resultTypeOption.forEach((element) => {
        if (element.id == "conversation") {
          this.model.result.push(element.id);
        }
      });
      if(this.currentUser.booker && this.currentUser.booker.status == 'Booker Manager'){
        this.model.bdrUserFilter = this.model.bdrUserFilter.filter(
          id => id !== this.currentUser.booker.user_id
        );
        let is_booker_manager = 1;
        this.getBDR(is_booker_manager);
      }
    } else {
      this.getBDR();
    }
    this.setHeader();
    this.getCalls();
  },
  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),

    getToDownload() {
        const allItems = 1; // cuando quieres pedir todos los resultados sin limite
        this.getCalls(allItems);
    },

    download() {   

      const nameDocument = "report-booker-calls.csv";

      //Tomo headers desde simpleheader
      const headers = this.headers.map(h => h.label);
      
      const fields = this.cols.map( item => {
        const value = (item[0].value) ? item[0].value : item[0].value_label;
        return value;
      })

      const rows = this.callsAllItems.map( item => {
        return fields.map( col => {
          return item[col];
        }).map(v => `"${String(v !== undefined && v !== null ? v : '').replace(/"/g, '""')}"`).join(",");
      })

      const csv = `${headers.join(",")}\n${rows.join("\n")}`;
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", nameDocument);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      },

    getBDR(is_booker_manager = 0) {
      usersService
        .getBdrs(0, 0, 0, 0, is_booker_manager)
        .then((res) => {
          this.bdrUserOptions = res.result;
          // this.selectUserBdr = true
        })
        .catch((err) => consolelog(err));
    },
    getCalls(allItems = 0) {
      this.model.allItems = allItems
      if(allItems === 1){        
        this.processingAllItems = true;
      } else {
        this.loading = true;
      }
      adminService.getCallsRingOver(this.model).then((res) => {
        if(allItems === 1){
          res.calls.forEach(item => {
            item.calification = this.normalizeCalification(item.calification)
          });
          this.callsAllItems = res.calls
          this.download()
          this.processingAllItems = false;
        } else {
          res.calls.forEach(item => {
            item.calification = this.normalizeCalification(item.calification)
          });
          this.calls = res.calls;
          this.total = parseInt(res.total);
          this.loading = false;
        }
        
      });
    },
    normalizeCalification(raw) {
        if (raw === null || raw === undefined || raw === "") {
          return "empty";
        }
        const s = String(raw).trim().toLowerCase();
        const compact = s.replace(/\s+/g, "_");
        if (
          s === "new meeting" ||
          compact === "new_meeting" ||
          s === "1" ||
          s === "newmeeting"
        ) {
          return "new_meeting";
        }
        if (
          s === "rescheduled meeting" ||
          compact === "rescheduled_meeting" ||
          s === "2" ||
          (s.includes("reschedule") && s.includes("meeting"))
        ) {
          return "rescheduled_meeting";
        }
        if (
          s === "no meeting" ||
          compact === "no_meeting" ||
          s === "3" ||
          s === "nomeeting"
        ) {
          return "no_meeting";
        }
        return "empty";
      },
    normalizeOptions(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },
    setHeader(route) {
      this.setCurrentRoute({ page: "bookers-calls", label: 'Bookers Calls' });
    },
    openClient(client_id) {
      //"client_id", client_id);
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
    openOportunity(oportunity) {
      let url = "/oportunities/" + oportunity;
      window.open(url, "_blank");
    },
    showTranscription(transcription){
        console.log(transcription);
       this.actualTranscription = transcription.transcription
       this.actualTranscription = this.actualTranscription.replace(/Contacto/g, transcription.to_number_call);
        this.$modal.show("transcription-modal", {
          transcription: transcription,
        });
    }
  },
};
</script>

<style scoped>
.banner {
  border-radius: 25em !important;
  color: #fff;
  font-size: 0.75em;
  text-align: left;
  margin-left: 1em;
  margin-right: 1em;
  margin-bottom: 0.2em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  background-color: #4d4deb;
  width: 98%;
}

.banner-message {
  margin-left: 2em;
  margin-right: 2em;
}

.w100p {
  width: 100px;
}

.overflowtable > span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

.ellipsis {
  text-overflow: ellipsis;
}

.overflowhide > span {
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
}

.overflowtable:hover {
  position: relative;
  padding: 0;
  vertical-align: inherit;
  text-align: left;
}

.overflowtable:hover > span {
  cursor: pointer;
  overflow: inherit;
  width: 100% !important;
  z-index: 999;
  position: absolute;
  border: 0;
  margin-top: -12px;
  margin-left: 12px;
  text-align: left;
  padding: 0;
  max-width: 100%;
  white-space: normal;
  background: rgb(236 236 236);
}

tr.table-primary .overflowtable:hover > span {
  background: #b7b9f6;
}

.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.overflowtable:hover > span > span {
}

#mytable .closed {
  display: none;
}

#mytable .opened {
  -webkit-animation: fadeIn 0.4s;
  animation: fadeIn 0.4s;
}

#mytable .openedlast {
  border-right: 2px solid #dee2e6;
}

/* .table {
  width: auto !important;
} */
table {
  width: 100%;
}

.label-hover {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}

.label-hover:hover {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}
.transcription {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 15px;
  background: #f0f0f0;
  max-height: 500px;
  overflow-y: auto;
  border-radius: 10px;
}

.bubble {
  max-width: 70%;
  padding: 10px 14px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-word;
}

.bubble.contact {
  align-self: flex-start;
  background-color: #ffffff;
  color: #HH3J3J3;
  border-top-left-radius: 0;
}

.bubble.user {
  align-self: flex-end;
  background-color: #dcf8c6;
  color: #000;
  border-top-right-radius: 0;
}

.bubble .message {
  margin: 0;
}
</style>

<style>
.transcription {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 15px;
  background: #f0f0f0;
  max-height: 500px;
  overflow-y: auto;
  border-radius: 10px;
}

.bubble {
  max-width: 70%;
  padding: 10px 14px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 0.7;
  white-space: pre-wrap;
  word-break: break-word;
}

.bubble.contact {
  align-self: flex-start;
  background-color: #ffffff;
  color: #333;
  border-top-left-radius: 0;
}

.bubble.user {
  align-self: flex-end;
  background-color: #dcf8c6;
  color: #000;
  border-top-right-radius: 0;
}

.bubble .message {
  margin: 0;
}
</style>